import React from 'react';
import { AAMBeaconButton, AAMBeaconModal } from 'components/shared/Beacon';
import '../BeneficiariesModal.scss';

const LeaveBeneConfirmation = ({ open, onClose, continueEditing }) => {
    return (
        <AAMBeaconModal
            open={open}
            id="beneficiaries_Leave_Bene_Confirmation"
            closeOnClickOut={false}
            onBeaconEventClose={continueEditing}>
            <h2 className="b-typography-serif--headline--200">Are you sure you want to leave?</h2>
            <div className="b-flow-space b-padding-block-end--macro--jumbo">
                <p>You haven&apos;t confirmed your changes.</p>
            </div>
            <div slot="action-zone" className='action-zone-align-right-exit-modal'>
                <div className="cancel-exit-modal">
                    <AAMBeaconButton
                        variant={'tertiary'}
                        onBeaconEventClick={continueEditing}
                    >
                        Continue Editing
                    </AAMBeaconButton>
                </div>
                <div className="right-exit-modal">
                    <AAMBeaconButton
                        type="submit"
                        onBeaconEventClick={onClose}
                        variant={'primary'}
                        className="continue-beacon-button"
                    >
                        Exit Without Confirming
                    </AAMBeaconButton>
                </div>
            </div>
        </AAMBeaconModal>
    );
};

export default LeaveBeneConfirmation;
